{
    "raporkampanya": {
        "Baslik": "Kampanya Raporu",
        "Kampanya": "Kampanya",
        "Kullanici": "Kullanıcı / Takım",
        "Detay": "Detay",
        "Urun": "Ürün",
        "HedefAdet": "Hedef Adet",
        "HedefTutar": "Hedef Tutar",
        "OnayliAdet": "Onaylı Adet",
        "OnayliTutar": "Onaylı Tutar",
        "OnayliApe": "Onaylı APE",
        "IptalAdet": "İptal Adet",
        "IptalTutar": "İptal Tutar",
        "IptalApe": "İptal APE",
        "CaymaAdet": "Cayma Adet",
        "Ara": "Sorgula",
        "Temizle": "Temizle",
        "Hedefler": "Hedefler",
        "Toplam": "Toplam",
        "Adet": "Adet",
        "Satislar": "Satışlar"
    }
}
